import React from 'react';
import PropTypes from 'prop-types';

import { CREDIT_CARD } from 'utils/prospectTypes';
import websitePage, { headerTypes } from 'hoc/websitePage/websitePage';

import SectionForm from './patterns/SectionForm/SectionForm';
import SectionUseYourPoints from './patterns/SectionUseYourPoints/SectionUseYourPoints';
import SectionKnowMore from './patterns/SectionKnowMore/SectionKnowMore';
import SectionTabsExplain from './patterns/SectionTabsExplain/SectionTabsExplain';
import SectionSignUp from './patterns/SectionSignUp/SectionSignUp';

function Rewards({ onFormVisibilityChange }) {
  return (
    <>
      <SectionForm onFormVisibilityChange={onFormVisibilityChange} />
      <SectionUseYourPoints />
      <SectionTabsExplain />
      <SectionSignUp />
      <SectionKnowMore />
    </>
  );
}

Rewards.propTypes = {
  onFormVisibilityChange: PropTypes.func.isRequired,
};

export default websitePage({
  routeKey: 'REWARDS',
  widgetProspectType: CREDIT_CARD,
  header: headerTypes.PRODUCT_PAGE,
})(Rewards);
